<div class="map">
    <ng-container *ngTemplateOutlet="loadingOverlay" />

    <kp-map
        #map
        [data]="mapData"
        [tileProvider]="tileProvider"
        [mapTilerToken]="mapTilerToken"
        [defaultLocation]="defaultLocation"
        [isEditable]="locationsPowerMap ? false : canEditMap"
        [locations]="locationsPowerMap"
        (mutation)="mapMutated($event)"
        (editStart)="editStart()"
        (editEnd)="editEnd()"
        (uploadImg)="uploadImg($event)"
        (setImg)="setImg($event)"
        (removeFeature)="removeFeature($event)"
        (featureClicked)="featureClicked($event)"
        (save)="save($event)"
        (cancel)="cancel()"
    ></kp-map>
    <!-- if no location yet.. -->
    <div class="control">
        <ng-container *ngIf="!hasLocation && !locationsPowerMap">
            <button
                mat-stroked-button
                (click)="setAsLocation()"
                *ngIf="canEditMap && isZoomedInEnoughForPlaceLocation"
            >
                <mat-icon svgIcon="c-location"></mat-icon>
                Place location here
            </button>
            <div class="note" *ngIf="!isZoomedInEnoughForPlaceLocation">Zoom in to place location</div>
        </ng-container>
    </div>
</div>

<section class="upload-state" *ngIf="uploadState.phase !== 'idle'" aria-live="polite">
    <div
        *ngIf="uploadState.phase === 'preparing' || uploadState.phase === 'uploading'"
        role="progressbar"
        [attr.aria-label]="uploadState.file?.name"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="uploadState.progress"
    >
        Uploading {{ uploadState.file?.name }} {{ uploadState.progress }}%
    </div>
    <button
        type="button"
        *ngIf="uploadState.phase === 'preparing' || uploadState.phase === 'uploading'"
        [attr.aria-label]="'Cancel ' + uploadState.file?.name"
        (click)="cancelUpload()"
    >
        Cancel
    </button>
    <p *ngIf="uploadState.phase === 'success'">{{ uploadState.message }}</p>
    <p *ngIf="uploadState.phase === 'error'">{{ uploadState.message }}</p>
    <button
        type="button"
        *ngIf="uploadState.phase === 'error' && uploadState.retryCount < 1"
        [attr.aria-label]="'Retry ' + uploadState.file?.name"
        (click)="retryUpload()"
    >
        Retry
    </button>
</section>

<ng-template #loadingOverlay>
    <ng-container *ngIf="(loadingMapData$ | async) || isSaving">
        <div class="loading-overlay">
            <mat-progress-spinner
                [mode]="'indeterminate'"
                [value]="50"
                [color]="'accent'"
                [diameter]="48"
                [strokeWidth]="4"
            ></mat-progress-spinner>
        </div>
    </ng-container>
</ng-template>
